/*
 *
 * PayByLinkTutorialPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 27-Mar-2025
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import PayByLinkTutorialPopup from './PayByLinkTutorialPopup'
import { doHidePopup } from 'Store/actions/popup'
import { doEvents } from 'Store/actions/global'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup()),
  doEvents: (payload) => dispatch(doEvents(payload))
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PayByLinkTutorialPopup)
